<template>
  <div class="top">
    {{ title }}
    <div class="actions">
      <span v-if="showTip" class="tip">您的浏览器设置阻止了消息的声音提示. 您可通过系统推送进行提醒, <a href="#" class="link"> 点击 </a>查看如何设置.如若您开启了系统推送,请忽略.</span>
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: this.$route.meta.title,
    };
  },
  computed:{
    showTip(){
      return this.$store.state.cicadeStore.hasInteracted
    }
  },
  mounted() {
    console.log("this.$route", this.$route.meta.title);
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.top {
  position: sticky;
  top: 0;
  z-index: 99;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  padding: 0 20px;
  font-size: 19px;
  font-weight: 500;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
}
.tip{
  font-size: 12px;
  padding: 8px;
  background: #fdf6ec;
  color: rgb(230, 162, 60);
  border-radius: 5px;
  cursor: default;
  .link{
    color: #1677ff;
  }
}
.actions {
  display: flex;
  align-items: center;
  gap: 5px;
}
</style>
